import {
  MAIN_PAGE_URL,
  AVT_MAIN_PAGE_URL,
  EXPAT_MAIN_PAGE_URL,
  IRE_MAIN_PAGE_URL,
  SPAIN_MAIN_PAGE_URL,
} from "@/constants";

const logoClickURLs = [
  {
    brand: "staysure",
    logoUrl: MAIN_PAGE_URL,
  },
  {
    brand: "avanti",
    logoUrl: AVT_MAIN_PAGE_URL,
  },
  {
    brand: "expat",
    logoUrl: EXPAT_MAIN_PAGE_URL,
  },
  {
    brand: "ireland",
    logoUrl: IRE_MAIN_PAGE_URL,
  },
  {
    brand: "spain",
    logoUrl: SPAIN_MAIN_PAGE_URL,
  },
];

export default logoClickURLs;
